import { isAxiosError } from "axios";

// The API's own messages are written for developers, so people get a plain version instead.
export function describeSubmitError(error: unknown): string {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  if (status === 400 || status === 413) return "Some of those details don't look right. Please check them and try again.";
  return "Something went wrong on our side. Please try again in a moment.";
}
